import '@elevationscu/ui-component-lib/dist/style.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import AppWithRouterAccess from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AppWithRouterAccess />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
